//#region Imports
/**
 * To use react functionality
 */
import React from 'react';
/**
Allows component  to connect the Redux store.
*/
import {connect} from 'react-redux';
/**
 * parse : The parse function to parse string value to date
 * isSameDay : The isSameDay function in React JS is used to check if two dates are on the same day. 
 * format : formats date
 * addMinutes: Add minutes to the current datetime object
 */
import { parse, isSameDay, format, addMinutes} from 'date-fns';
/**
To use TripLeg Component
*/
import TripLeg from '../Directions/TripLeg';

//#endregion

const TripDetails = props => {

//#region variable declaration

//stores props values
const {trips,currentTrip,label} = props;

//stores selected trip details
const trip = trips[currentTrip]

//stores request date
const requestStart = parse(props.requestDate);

//stores agency offset used to calculate timezone difference
const agencyOffset = (trip.legs[0].agencyTimeZoneOffset) / (60 * 1000);

//stores current date time
const today = new Date();

//stores time zone difference
const timezoneDiff = agencyOffset + today.getTimezoneOffset();

//store trip start timing
const tripStart = addMinutes(parse(trip.startTime), timezoneDiff);

//#endregion

//#region returns component html

return(
    <div className='otp-accordion-section open'>           
        <div
            className="otp-accordion-panel"
            id={`otp-accordion-panel-${label}`}
        >               
            {!isSameDay(tripStart, requestStart) &&
                    <div className="otp-directions-caption">Trip Date: {format(tripStart, 'dddd, MMMM Do')}</div>}
            {trip.legs.map((leg, idx) => {
                const key = leg.duration.toString() + leg.startTime.toString();
                return (<TripLeg details={leg} key={key} idx={idx} />);
            })}
                     
        </div>
       
    </div>
);

//#endregion

};

//#region store related function
//maps the state from the Redux store
const mapStateToProps = state => {
    //returns single props "requestDate"
    return {
        requestDate: state.form.fields.date.value,
    };    
};

//#endregion

export default connect(mapStateToProps)(TripDetails);